import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiPut } from "../../../utils/apiRequests";
import {
  SUBMIT_SCORE_LOADING,
  SUBMIT_SCORE_ERROR,
  SUBMIT_SCORE_SUCCESS,
  CLEAR_SUBMIT_SCORE,
} from "../../../constant/actionTypes";

export const submitScore = (payload) => (dispatch) => {
  dispatch({ type: SUBMIT_SCORE_LOADING });

  apiPut(
    `${ApiEndpoints.league.base}${ApiEndpoints.league.scoreEntry}`,
    payload,
    (response) => {
      if (response.error == true) {
        dispatch({
          type: SUBMIT_SCORE_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: SUBMIT_SCORE_SUCCESS, response: response });
        dispatch({ type: CLEAR_SUBMIT_SCORE });
      }
    },
    (error) => {
      dispatch({ type: SUBMIT_SCORE_ERROR, response: error });
    }
  );
};
